export function products(){
	if($(".PRODUCTS").length > 0){
		$(".inBox").mCustomScrollbar({
			horizontalScroll: Boolean,
			  advanced:{
				updateOnContentResize: true
			  }
		});
	}
	
	if($(".PRODUCTS_DETAIL").length > 0){
		//swiper
		//メインスライド
		  var mainSlideOption = {
			loop           : true,
		  }
		  var mainSlide = new Swiper('#slide', mainSlideOption);

		  //サムネイルスライド
		  var thumbnailOption = {
			loop                  : true,
			spaceBetween          : 10,
			slidesPerView         : 5,
			slideToClickedSlide   : true,
			centeredSlides        : true
		  };
		  var thumbnail = new Swiper('#thumbnail', thumbnailOption);

		  //サムネイルをクリックした時のイベント
		  $(document).on('click', '#thumbnail .swiper-slide', (e) => {
			if(thumbnail){
			  mainSlide.slideToLoop(thumbnail.realIndex);
			}
			else{
			  var index = $('#thumbnail .swiper-slide').index(e.currentTarget);
			  mainSlide.slideToLoop(index);
			}
		  });

		  //メインスライドが動いた時のイベント
		  mainSlide.on('slideChange', () => {
			if($(window).innerWidth() < 768){
			  thumbnail.slideToLoop(mainSlide.realIndex);
			}
			else {
			  $('#thumbnail .swiper-slide').removeClass('is-active');
			  $('#thumbnail .swiper-slide').eq(mainSlide.realIndex).addClass('is-active');
			}
		  });

		  var resizeTimer = null;
		  var resizeFlag  = true;
		  //リサイズイベント
		  $(window).on('load resize', () => {
			if(resizeFlag){
			  resizeFlag = false;
			  if(resizeTimer){
				window.cancelAnimationFrame(resizeTimer);
			  }
			  resizeTimer = window.requestAnimationFrame(() => {
				if($(window).innerWidth() >= 768){
				  if(thumbnail){
					thumbnail.destroy();
					thumbnail = null;
					$('#thumbnail .swiper-wrapper').removeAttr('style');
					$('#thumbnail .swiper-slide').removeAttr('style');
					$('#thumbnail .swiper-slide').eq(mainSlide.realIndex).addClass('is-active');
				  }
				}
				else {
				  $('#thumbnail .swiper-slide').removeClass('is-active');
				  if(!thumbnail){
					thumbnail = new Swiper('#thumbnail', thumbnailOption);
				  }
				}
				resizeFlag = true;
			  });
			}
		  });	
	}
	
}